import $ from '@rover/globals/jquery';
import Rover from '@rover/globals/Rover';
import dataLayer from '@rover/globals/dataLayer';

Rover.utils = Rover.utils || {};

Rover.utils.scrollTo = function(selector, speed) {
  if (!speed) {
    speed = 'fast';
  }

  const top =
    $(selector).offset().top -
    $('.navbar-header').height() -
    $('.header-toolbar-wrapper').height() -
    20;

  $('html,body').animate(
    {
      scrollTop: top,
    },
    speed
  );
};

export const scrollTo = Rover.utils.scrollTo;

export const trackContactProviderClick = isUserLoggedIn => {
  dataLayer.push({
    event: 'record-event',
    event_name: isUserLoggedIn ? 'CSC - logged in' : 'CSC - not logged in',
  });
};

export const isElBelowViewportTop = $el => {
  const rect = $el[0].getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0;
};

export const isElAboveViewportBottom = $el => {
  const rect = $el[0].getBoundingClientRect();
  return (
    rect.top + rect.height <= window.innerHeight && rect.left + rect.width <= window.innerWidth
  );
};

Rover.utils.getBreakpoint = function() {
  let w = $(window).width(),
    breakpoints = {
      lg: 1200,
      md: 992,
      sm: 768,
      xs: 0,
    };

  if (w >= breakpoints.lg) {
    return 'lg';
  } else if (w >= breakpoints.md) {
    return 'md';
  } else if (w >= breakpoints.sm) {
    return 'sm';
  }
  return 'xs';
};

/*
 *  inViewport($el)
 *
 *  Returns the height, in pixels, of $el
 */
Rover.utils.getElemVisibleY = function($elem) {
  const elH = $elem.outerHeight();
  const H = $(window).height();
  const r = $elem[0].getBoundingClientRect();
  const t = r.top;
  const b = r.bottom;
  return Math.max(0, t > 0 ? Math.min(elH, H - t) : b < H ? b : H);
};

Rover.utils.parallel = function(funcs, allDone) {
  let counter = funcs.length,
    cb;

  cb = function() {
    counter--;
    if (counter === 0) {
      if (_.isFunction(allDone)) {
        allDone();
      }
    }
  };

  for (let i = 0; i < funcs.length; i++) {
    funcs[i](cb);
  }
};

export const createThenableDebouncer = () => {
  /**
    Think of this as a debounce for Promises. Rather than waiting some amount
    of time before it allows a call to execute, it waits for last pending
    Promise to resolve.

    This creates a function which when passed functions which return thenables
    (i.e. Promises) will execute the most recently passed function only if
    there is no pending thenable.

    Usage:
    import { createThenableDebouncer } from './app/js/utilities/ui';
    var debouncer = createThenableDebouncer();
    debouncer(new Promise(...do stuff...));
    debouncer(new Promise(...do stuff...));
    debouncer(new Promise(...do stuff...));
    debouncer(new Promise(...do stuff...));
    * */
  let nextFunc;
  let runner;

  function runComplete() {
    const thenableFunc = nextFunc;
    runner = null;

    if (thenableFunc) {
      nextFunc = null;
      runner = startRun(thenableFunc);
    }
  }

  function startRun(thenableFunc) {
    return thenableFunc().then(runComplete);
  }

  function run(thenableFunc) {
    if (!runner) {
      runner = startRun(thenableFunc);
    } else {
      nextFunc = thenableFunc;
    }
  }

  return run;
};

export default {
  trackContactProviderClick,
  isElAboveViewportBottom,
  isElBelowViewportTop,
  createThenableDebouncer,
};



// WEBPACK FOOTER //
// ../utilities/ui.js